import { render, staticRenderFns } from "./configuration-local-assays-assays-laboratory-grid.vue?vue&type=template&id=c06d5cf0&scoped=true&"
import script from "./configuration-local-assays-assays-laboratory-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-assays-assays-laboratory-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-assays-assays-laboratory-grid.scss?vue&type=style&index=0&id=c06d5cf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06d5cf0",
  null
  
)

export default component.exports